import React from 'react';

export const DragSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="4" r="2" fill="currentColor" />
    <circle cx="8" cy="12" r="2" fill="currentColor" />
    <circle cx="8" cy="20" r="2" fill="currentColor" />
    <circle cx="16" cy="4" r="2" fill="currentColor" />
    <circle cx="16" cy="12" r="2" fill="currentColor" />
    <circle cx="16" cy="20" r="2" fill="currentColor" />
  </svg>
);

export default DragSvg;
